export const Variants = {
  HEADING: 'heading', //Size:14,Weight:600,color:#333
  HEADING_LARGE: 'headingLarge', //Size:16,Weight:600,color:#333
  SECONDARY: 'secondary', //Size:14,Weight:400,color:#666
  PRIMARY: 'primary', //Size:14,Weight:400,color:#333
  SMALL: 'small', //Size:12,Weight:400,color:#333
  HEIGHLIGHT: 'heighLight', //Size:14,Weight:400,color:#101010
};

export const VariantStyles = {
  [Variants.HEADING]: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 600,
    color: '#333333',
  },
  [Variants.HEADING_LARGE]: {
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 600,
    color: '#333333',
  },
  [Variants.SECONDARY]: {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: 400,
    color: '#666666',
  },
  [Variants.PRIMARY]: {
    fontSize: 14,
    fontWeight: 400,
    color: '#333333',
  },
  [Variants.SMALL]: {
    fontSize: '12px',
    lineHeight: '12px',
    fontWeight: 400,
    color: '#333333',
  },
  [Variants.HEIGHLIGHT]: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#101010',
  },
};
